export enum RevStatus {
  NoRev1Complete = 1,
  Rev1Complete = 2,
  Rev2Complete = 3,
}